import api from './api.service';
import {
  IAuthResponse,
  ILoginCredentials,
  IUsuario,
} from '../types/usuario.types';

export const authService = {
  login: async (credentials: ILoginCredentials): Promise<IAuthResponse> => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },

  logout: async (): Promise<void> => {
    try {
      await api.post('/auth/logout');
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
    }
  },

  refreshToken: async (): Promise<{ token: string }> => {
    const refreshToken = localStorage.getItem('refreshToken');
    const response = await api.post('/auth/refresh-token', { refreshToken });
    const { token } = response.data.data;
    localStorage.setItem('token', token);
    return { token };
  },

  changePassword: async (
    oldPassword: string,
    newPassword: string,
  ): Promise<void> => {
    await api.post('/auth/change-password', {
      passwordActual: oldPassword,
      passwordNuevo: newPassword,
    });
  },

  getCurrentUser: async (): Promise<IUsuario> => {
    const response = await api.get('/auth/me');
    return response.data.data;
  },
};
